import { useCallback, useEffect, useState } from 'react';

import { Button } from '@/components/Button';
import { ReviewCard } from '@/components/ReviewCard';
import SearchBar from '@/components/SearchBar';
import { Spinner } from '@/components/Spinner';
import useDebounce from '@/hooks/useDebounce';
import { useTitle } from '@/hooks/useTitle';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { requestHowToReviews } from '@/store/modules/howToReviews';
import styles from './styles.module.scss';

const PAGE_SIZE = 8;

export function HowToReviewsPage() {
  useTitle('DienTEA | Vídeos explicativos');
  const dispatch = useAppDispatch();
  const { list, loading, total } = useAppSelector((state) => state.howToReviews);

  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);

  const hasMore = total > list.length;
  const endReached = total === list.length && list.length > 0;

  useEffect(() => {
    dispatch(
      requestHowToReviews({
        page: 0,
        pageSize: PAGE_SIZE,
        title: debouncedSearch
      })
    );
  }, [debouncedSearch, dispatch]);

  const loadMore = useCallback(async () => {
    if (loading || !hasMore) return;
    await dispatch(
      requestHowToReviews({
        page: list.length / PAGE_SIZE,
        pageSize: PAGE_SIZE,
        title: debouncedSearch
      })
    );
  }, [list.length, loading, hasMore, dispatch, debouncedSearch]);

  return (
    <div className={styles.reviewsPage}>
      <section className={styles.container}>
        <div className={styles.sectionHeader}>
          <SearchBar value={search} onChange={setSearch} />
        </div>

        {total === 0 && !loading ? <p>No se han encontrado vídeos explicativos.</p> : null}

        <div className={styles.reviews}>
          {list.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {!list.length && debouncedSearch ? <p>No se han encontrado resultados para "{debouncedSearch}".</p> : null}

        {hasMore ? (
          <>
            {loading && <Spinner />}

            <div className={styles.btnContainer}>
              <Button onClick={loadMore}>{loading ? 'Cargando...' : 'Cargar más'}</Button>
            </div>
          </>
        ) : endReached ? (
          <div className={styles.endMessage}>
            <p>✨ Has visto todos los videos explicativos ✨</p>
          </div>
        ) : null}
      </section>
    </div>
  );
}
